import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/index/Home'
import Supplier from '@/pages/supplier_channel/Supplier'
import Business from '@/pages/platform_goods/Business'
import Pages from '@/pages/yihuo_page/Pages'
import Platform from '@/pages/platform/Platform'
import Category from '@/pages/category/Category'
import Goods from '@/pages/goods/Goods'
import Search from '@/pages/search/Result'
import Result from '@/pages/search_result/Goods'
import Detail from '@/pages/detail/Detail'
import Confirm from '@/pages/confirm/Confirm'
import Subsucc from '@/pages/submit_success/Subsucc'
import Pay from '@/pages/pay/Pay'
import Me from '@/pages/me/Me'
import Logon from '@/pages/log_on/Logon'
import Validate from '@/pages/validate/Validate'
import Forgetword from '@/pages/forget_password/Forgetword'
import AccountRecord from '@/pages/account_record/AccountRecord'
import Transfer from '@/pages/transfer/Transfer'
import Transacc from '@/pages/transfer_accounts/Transacc'
import Recharge from '@/pages/recharge/Recharge'
import Sell from '@/pages/sell_goods/Sell'
import Nopass from '@/pages/not_pass/Nopass'
import Order from '@/pages/order_form/Order'
import Selled from '@/pages/selled_goods/Selled'
import Store from '@/pages/my_store/Store'
import Checklist from '@/pages/checklist/Checklist'
import List from '@/pages/yihuo_list/List'
import Release from '@/pages/release/Release'
import Reviselogword from '@/pages/revise_logon_password/Reviselogword'
import Reviselogwordvalidate from '@/pages/revise_logon_password_validate/Validate'
import Revisepayword from '@/pages/revise_pay_password/Revisepayword'
import Revisepaywordvalidate from '@/pages/revise_pay_password_validate/Validate'
import Changetel from '@/pages/change_tel/Changetel'
import Shopping from '@/pages/shopping/Shopping'
import Emptyshop from '@/pages/empty_shopping/Emptyshop'
import Verify from '@/pages/identify_verify/Verify'
import Slist from '@/pages/list/Slist'
import Orderdetail from '@/pages/order_detail/Detail'
import Settleaccount from '@/pages/settle_account/Settle'
import Wechatpay from '@/pages/wechat_pay/Pay'
import Selledorder from '@/pages/selled_detail/Detail'
import Posttrade from '@/pages/post_trade/Posttrade'
import Error from '@/pages/error/Error'
import Consume from '@/pages/consume/Consume'
import About from '@/pages/about/About'
import Service from '@/pages/service/Service'
import License from '@/pages/license/License'
import Secret from '@/pages/secret/Secret'
import ClientList from '@/pages/clientlist/ClientList'
import AddClient from '@/pages/addclient/AddClient'
import EditClient from '@/pages/editclient/EditClient'
import TransferItem from '@/pages/transfer_item/TransferItem'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    }, {
      path: '/supplier_channel',
      name: 'Supplier',
      component: Supplier
    }, {
      path: '/platform_goods',
      name: 'Business',
      component: Business
    }, {
      path: '/yihuo_page',
      name: 'Pages',
      component: Pages
    }, {
      path: '/platform/:id',
      name: 'Platform',
      component: Platform
    }, {
      path: '/category',
      name: 'Category',
      component: Category
    }, {
      path: '/goods/:id',
      name: 'Goods',
      component: Goods
    }, {
      path: '/search',
      name: 'Search',
      component: Search
    }, {
      path: '/search_result',
      name: 'Result',
      component: Result
    }, {
      path: '/detail/:id',
      name: 'Detail',
      component: Detail
    }, {
      path: '/confirm',
      name: 'Confirm',
      component: Confirm
    }, {
      path: '/submit_success',
      name: 'Subsucc',
      component: Subsucc
    }, {
      path: '/pay',
      name: 'Pay',
      component: Pay
    }, {
      path: '/me',
      name: 'Me',
      component: Me
    }, {
      path: '/log_on',
      name: 'Logon',
      component: Logon
    }, {
      path: '/validate',
      name: 'Validate',
      component: Validate
    }, {
      path: '/forget_password',
      name: 'Forgetword',
      component: Forgetword
    }, {
      path: '/account_record',
      name: 'AccountRecord',
      component: AccountRecord
    }, {
      path: '/transfer',
      name: 'Transfer',
      component: Transfer
    }, {
      path: '/transfer_accounts',
      name: 'Transacc',
      component: Transacc
    }, {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    }, {
      path: '/sell_goods',
      name: 'Sell',
      component: Sell
    }, {
      path: '/order_form',
      name: 'Order',
      component: Order
    }, {
      path: '/not_pass',
      name: 'Nopass',
      component: Nopass
    }, {
      path: '/selled_goods',
      name: 'Selled',
      component: Selled
    }, {
      path: '/my_store',
      name: 'Store',
      component: Store
    }, {
      path: '/checklist',
      name: 'Checklist',
      component: Checklist
    }, {
      path: '/yihuo_list',
      name: 'List',
      component: List
    }, {
      path: '/release',
      name: 'Release',
      component: Release
    }, {
      path: '/revise_logon_password',
      name: 'Reviselogword',
      component: Reviselogword
    }, {
      path: '/revise_logon_password_validate',
      name: 'Reviselogwordvalidate',
      component: Reviselogwordvalidate
    }, {
      path: '/revise_pay_password',
      name: 'Revisepayword',
      component: Revisepayword
    }, {
      path: '/revise_pay_password_validate',
      name: 'Revisepaywordvalidate',
      component: Revisepaywordvalidate
    }, {
      path: '/change_tel',
      name: 'Changetel',
      component: Changetel
    }, {
      path: '/shopping',
      name: 'Shopping',
      component: Shopping
    }, {
      path: '/empty_shopping',
      name: 'Emptyshop',
      component: Emptyshop
    }, {
      path: '/identify_verify',
      name: 'Verify',
      component: Verify
    }, {
      path: '/list/:id',
      name: 'Slist',
      component: Slist
    }, {
      path: '/order_detail',
      name: 'Orderdetail',
      component: Orderdetail
    }, {
      path: '/settle_account',
      name: 'Settleaccount',
      component: Settleaccount
    }, {
      path: '/wechat_pay',
      name: 'Wechatpay',
      component: Wechatpay
    }, {
      path: '/selled_detail/:id',
      name: 'Selledorder',
      component: Selledorder
    }, {
      path: '/post_trade',
      name: 'Posttrade',
      component: Posttrade
    }, {
      path: '/error',
      name: 'Error',
      component: Error
    }, {
      path: '/consume',
      name: 'Consume',
      component: Consume
    }, {
      path: '/about',
      name: 'About',
      component: About
    }, {
      path: '/service',
      name: 'Service',
      component: Service
    }, {
      path: '/license',
      name: 'License',
      component: License
    }, {
      path: '/secret',
      name: 'Secret',
      component: Secret
    }, {
      path: '/clientlist',
      name: 'clientlist',
      component: ClientList
    }, {
      path: '/addclient',
      name: 'addclient',
      component: AddClient
    }, {
      path: '/editclient',
      name: 'editclient',
      component: EditClient
    }, {
      path: '/transferitem',
      name: 'transferitem',
      component: TransferItem
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  } // 每次切换页面时都从x=0,y=0时开始展示
})



// WEBPACK FOOTER //
// ./src/router/index.js